module.exports = __webpack_public_path__ + "media/13.1e0e4eb0.mp3";